// extracted by mini-css-extract-plugin
export default {"channel-info":"styles_channel-info__ZrMnP","channel-info__title":"styles_channel-info__title__OokC2","channel-info__links":"styles_channel-info__links__cPrsh"};